export const staticAMMHistory = [
  {
    "blocktime": 1711911231,
    "endGaia": 0.9814999563301703,
    "endCoin": 37073.288,
    "gaiaCoin": 37772.073
  },
  {
    "blocktime": 1711911257,
    "endGaia": 0.9898279754998506,
    "endCoin": 39796.983,
    "gaiaCoin": 40205.959
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9949257941624208,
    "endCoin": 42460.079,
    "gaiaCoin": 42676.629
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9952114589224108,
    "endCoin": 45005.992,
    "gaiaCoin": 45222.542
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9934806524183701,
    "endCoin": 47495.261,
    "gaiaCoin": 47806.931
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9909921442193232,
    "endCoin": 49956.683,
    "gaiaCoin": 50410.776
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9869824640654151,
    "endCoin": 52363.341,
    "gaiaCoin": 53053.973
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9892949103219536,
    "endCoin": 54967.186,
    "gaiaCoin": 55561.982
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9889476091006907,
    "endCoin": 57484.618,
    "gaiaCoin": 58127.061
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9847704949997087,
    "endCoin": 59864.353,
    "gaiaCoin": 60790.157
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9861336236985279,
    "endCoin": 62439.069,
    "gaiaCoin": 63317.047
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9782271285996572,
    "endCoin": 64663.473,
    "gaiaCoin": 66102.719
  },
  {
    "blocktime": 1711911258,
    "endGaia": 0.9763000456041735,
    "endCoin": 67097.359,
    "gaiaCoin": 68726.166
  }
]